var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgErrorNotification = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 14,
  fill: "#F2CACA"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.924 19.231V8.461h2.154v10.77h-2.154ZM14.924 23.539v-2.154h2.154v2.154h-2.154Z",
  fill: "#D65F5C"
})));
export default SvgErrorNotification;